import { create } from 'zustand';

interface State {
  phoneNumber: string | null;
  setPhoneNumber: (phoneNumber: string) => void;
}

// this store is plugged only in checkout
// TODO:implement in other components with phone input
const usePhoneNumberInputStore = create<State>((set) => ({
  phoneNumber: null,
  setPhoneNumber: (phoneNumber) => set({ phoneNumber })
}));

export default usePhoneNumberInputStore;
